
import ko from 'rgs-knockout';

const Model = require('./js/model');
const template = require('./templates/template.html');


ko.components.register('settlement-select-tip', {
	viewModel: Model,
	template: template(),
});

